// Which store theme the top nav wears. A store's theme (e.g. Black) belongs to that store's pages only — it must
// end the moment the shopper leaves them, not linger on the marketplace until a refresh.
//   • a signed-in seller: their own store's template, everywhere;
//   • a shopper on /store/<slug> (or a store's own subdomain): THAT store's template, found from the URL;
//   • a shopper on /cart: the template of the cart's store when the cart holds a single store;
//   • anywhere else (home, categories, product, account, …): the default look.
const norm = (s) => String(s || "").toLowerCase();

export function navTemplateFor({ isSeller, sellerTemplate, users, pathname, subdomainSlug, cart, slugToSubdomain }) {
  if (isSeller) return sellerTemplate || "default";
  const list = Array.isArray(users) ? users : [];
  const path = String(pathname || "/");
  let store = null;
  const m = path.match(/^\/store\/([^/?#]+)/);
  if (m) {
    let slug = m[1]; try { slug = decodeURIComponent(slug); } catch { /* keep raw */ }
    store = list.find(u => norm(u.store_slug) === norm(slug)) || null;
  } else if (subdomainSlug && (path === "/" || path === "")) {
    store = list.find(u => typeof slugToSubdomain === "function" && slugToSubdomain(u.store_slug) === subdomainSlug) || null;
  } else if (/^\/cart(\/|$)/.test(path)) {
    const ids = [...new Set((Array.isArray(cart) ? cart : []).map(i => i && i.user_id).filter(Boolean))];
    if (ids.length === 1) store = list.find(u => u.id === ids[0]) || null;
  }
  return (store && store.template) || "default";
}
